import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../hooks/useRootStore';
import { Box, Button, Link, TextField } from '@mui/material';
import md5 from "md5";

const Login = observer(() => {
    const { api } = useRootStore();
    const [userLogin, setUserLogin] = useState(document.getElementById('login')?.nodeValue ?? '');
    const [userPassword, setUserPassword] = useState(document.getElementById('password')?.nodeValue ?? '');

    const handleLogin = () => {
        api.signIn(userLogin, md5(userPassword));
    };

    return (
        <div style={{ paddingTop: 150 }} >
            <Box sx={{ padding: "15px" }}>
                <TextField
                    id="login"
                    label="Логин"
                    variant="outlined"
                    slotProps={{
                    }}
                    onChange={(e) => setUserLogin(e.target.value)}
                />
            </Box>
            <Box>
                <TextField
                    type="password"
                    className="white"
                    autoComplete="current-password"
                    id="password"
                    label="Пароль"
                    variant="outlined"
                    onChange={(e) => setUserPassword(e.target.value)}
                />
            </Box>
            <Box sx={{ paddingTop: "15px" }}>
                <Button onClick={handleLogin}>Войти</Button>
            </Box>
            <Box>
                <Link href="./requestresetpassword">Восстановить пароль</Link>
            </Box>
        </div>
    );
});

export default Login;